import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HydroroofStats from "./sections/HydroroofStats";
import Technology from "./sections/Technology";
import Services from "./sections/Services";
import Projects from "./sections/Projects";
import Testimonials from "./sections/Testimonials";
import Zabezpiecz from "./sections/Zabezpiecz";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <HydroroofStats />
      <Technology />
      <Services />
      <Projects />
      <Testimonials />
      <Zabezpiecz />
      <Footer />
    </div>;
}